<template>
  <div v-if="product != null">
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Ürün Çeviri">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span>
                <strong>Not:</strong>
                Ürünü çevirisini eklemek için aşağıdaki alanları doldurunuz.
              </span>
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/catalog/products?page=${page}`"
          >
            Ürün Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Ürün Çeviri Formu">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Başlık" label-for="title">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true, max: chars.title }"
                    name="Başlık"
                  >
                    <b-form-input
                      id="title"
                      v-model="title"
                      placeholder="Başlık"
                      :state="errors.length > 0 ? false : null"
                      :class="title.length >= chars.title ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="title.length >= chars.title ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ title.length }}</span>
                      /
                      {{ chars.title }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Kısa Açıklama" label-for="shortDescription">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Kısa Açıklama"
                  >
                    <b-form-textarea
                      id="shortDescription"
                      v-model="shortDescription"
                      placeholder="Kısa Açıklama"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        shortDescription.length >= chars.shortDescription
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        shortDescription.length >= chars.shortDescription
                          ? 'bg-danger'
                          : ''
                      "
                    >
                      <span class="char-count">{{ shortDescription.length }}</span>
                      /
                      {{ chars.shortDescription }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Uzun Açıklama" label-for="longDescription">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Uzun Açıklama"
                  >
                    <b-form-textarea
                      id="longDescription"
                      v-model="longDescription"
                      placeholder="Uzun Açıklama"
                      rows="12"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        longDescription.length >= chars.longDescription
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        longDescription.length >= chars.longDescription ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ longDescription.length }}</span>
                      /
                      {{ chars.longDescription }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Ödüller" label-for="text">
                  <div>
                    <b-form
                      ref="form"
                      class="repeater-form mb-5"
                      @submit.prevent="repeateAgain"
                    >
                      <!--  Loop -->
                      <div
                        v-for="(awardItem, i) in awards"
                        :id="`award-item-${i}`"
                        :key="`award-item-${i}`"
                        ref="row"
                      >
                        <b-row>
                          <hr />
                        </b-row>
                        <b-row>
                          <b-col md="12">
                            <b-form-group label="Ödül Adı" :label-for="`awardName${i}`">
                              <validation-provider
                                #default="{ errors }"
                                :rules="{ required: false }"
                                name="Ödül Adı"
                              >
                                <b-form-input
                                  v-model="awardItem.name"
                                  placeholder="Ödül Adı"
                                  :id="`awardName${i}`"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    awardItem.name.length >= chars.awardName
                                      ? 'text-danger'
                                      : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="
                                    awardItem.name.length >= chars.awardName
                                      ? 'bg-danger'
                                      : ''
                                  "
                                >
                                  <span class="char-count">{{
                                    awardItem.name.length
                                  }}</span>
                                  /
                                  {{ chars.awardName }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="12">
                            <b-form-group label="Ödül Yılı" :label-for="`awardYear${i}`">
                              <validation-provider
                                #default="{ errors }"
                                :rules="{
                                  required: false,
                                }"
                                name="Ödül Yılı"
                              >
                                <b-form-input
                                  v-model="awardItem.year"
                                  placeholder="Ödül Yılı"
                                  :id="`awardYear${i}`"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    awardItem.year.length >= chars.awardYear
                                      ? 'text-danger'
                                      : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="
                                    awardItem.year.length >= chars.awardYear
                                      ? 'bg-danger'
                                      : ''
                                  "
                                >
                                  <span class="char-count">{{
                                    awardItem.year.length
                                  }}</span>
                                  /
                                  {{ chars.awardYear }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Remove Button -->
                          <b-col lg="2" md="3" class="mb-50">
                            <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="mt-0 mt-md-2"
                              @click="removeItem(index)"
                            >
                              <feather-icon icon="XIcon" class="mr-25" />
                              <span>Sil</span>
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-row>
                          <hr />
                        </b-row>
                      </div>
                    </b-form>
                  </div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="repeateAgain"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>Ekle</span>
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="productFeatures.length > 0">
              <b-col md="12">
                <b-card class="mb-3" title="Ürün Özellikleri">
                  <b-row
                    v-for="(productFeature, i) in productFeatures"
                    :key="`product-feature-${i}`"
                  >
                    <b-col md="12">
                      <b-form-group label="Açıklama" :label-for="`description${i}`">
                        <validation-provider
                          #default="{ errors }"
                          :rules="{ required: true }"
                          name="Açıklama"
                        >
                          <b-form-textarea
                            :id="`description${i}`"
                            v-model="productFeature.description"
                            placeholder="Kısa Açıklama"
                            rows="12"
                            :state="errors.length > 0 ? false : null"
                            :class="
                              productFeature.description.length >= chars.description
                                ? 'text-danger'
                                : ''
                            "
                          />
                          <small
                            class="textarea-counter-value float-right"
                            :class="
                              productFeature.description.length >= chars.description
                                ? 'bg-danger'
                                : ''
                            "
                          >
                            <span class="char-count">{{
                              productFeature.description.length
                            }}</span>
                            /
                            {{ chars.description }}
                          </small>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mt-5"></b-col>
              <b-col md="6" class="mt-5">
                <b-button
                  class="float-right mt-2"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-success"
                  @click="postConfirmText(0)"
                >
                  <b-spinner v-if="spinner === true && isDraft === 0" small />
                  {{ spinner === true && isDraft === 0 ? "Yayınlanıyor" : "Yayınla" }}
                </b-button>
                <b-button
                  class="float-right mt-2 mr-1"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning"
                  @click="postConfirmText(1)"
                >
                  <b-spinner v-if="spinner == true && isDraft == 1" small />
                  {{
                    spinner == true && isDraft == 1
                      ? "Taslağa Kaydediliyor"
                      : "Taslağa Kaydet"
                  }}
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import { heightTransition } from "@core/mixins/ui/transition";
import DragDropImage from "../../components/DragDropImage.vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BLink,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormFile,
  BCardText,
  BMediaBody,
  BFormInput,
  BFormGroup,
  BMediaAside,
  BInputGroup,
  BFormTextarea,
  BFormDatepicker,
  BFormTimepicker,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  max,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormTimepicker,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    max,
    digits,
    alphaDash,
    length,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id: null,
      idParam: this.$route.params.idParam,
      page: this.$route.query.page ? this.$route.query.page : 1,
      targetLocale: this.$route.query.targetLocale,
      product: null,
      productFeatures: [],
      title: "",
      longDescription: "",
      shortDescription: "",
      isDraft: 0,
      spinner: false,
      nextTodoId: 1,
      awards: [
        {
          id: 1,
          name: "",
          year: "",
        },
      ],
      chars: {
        year: 255,
        title: 255,
        awardName: 1000,
        longDescription: 5000,
        shortDescription: 2500,
      },
    };
  },

  methods: {
    repeateAgain() {
      this.awards.push({
        id: (this.nextTodoId += 1),
        name: "",
        year: "",
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.awards.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Ürünü çevirisini eklemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();

          formData.append("id", this.id);
          formData.append("title", this.title);
          formData.append("description", this.description);
          formData.append("longDescription", this.longDescription);
          formData.append("shortDescription", this.shortDescription);
          formData.append("isDraft", this.isDraft);
          formData.append("awards", JSON.stringify(this.awards));

          endpoints
            .postCatalogProductsTranslation(formData, this.targetLocale, () => {})
            .then((data) => {
              this.spinner = false;
              this.$swal({
                icon: "success",
                title: "Kayıt başarılı!",
                text: "Ürün çevirisi eklendi.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then((result) => {
                if (result.value) {
                  this.$router.push({
                    path: `/catalog/products?page=${this.page}`,
                  });
                }
              });
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
    getCatalogProductsById() {
      endpoints
        .getCatalogProductsById(this.idParam, this.$i18n.locale, () => {})
        .then((data) => {
          this.id = data.response.id;
          this.product = data.response;
          this.title = data.response.title;
          this.awards = data.response.awards;
          this.longDescription = data.response.longDescription;
          this.shortDescription = data.response.shortDescription;
          this.productFeatures = data.response.productFeatures;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getCatalogProductsById();
    localize("tr");
  },
  setup() {},
};
</script>
<style lang="css">
.ql-container {
  margin-top: 30px;
}

.ql-container,
.ql-editor {
  min-height: 300px !important;
  margin-bottom: 30px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
